const CART_KEY = "cs_cart";
const PAYMENT_KEY = "cs_payment";
const ART_URL_KEY = "cs_art_url";

function readJson(key, fallback) {
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
}

function writeJson(key, value) {
  try {
    if (value == null) sessionStorage.removeItem(key);
    else sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* ignore quota */
  }
}

export function readShopCart() {
  const value = readJson(CART_KEY, []);
  return Array.isArray(value) ? value : [];
}

export function saveShopCart(items) {
  const list = Array.isArray(items) ? items : [];
  writeJson(CART_KEY, list);
  return list;
}

export function readShopPayment() {
  const value = readJson(PAYMENT_KEY, {});
  return value && typeof value === "object" ? value : {};
}

export function saveShopPayment(payment) {
  const next = payment && typeof payment === "object" ? payment : {};
  writeJson(PAYMENT_KEY, next);
  return next;
}

export function readShopArtUrl() {
  try {
    return String(sessionStorage.getItem(ART_URL_KEY) || "").trim();
  } catch {
    return "";
  }
}

export function readLatestShopArtUrl(locationState, stored = {}) {
  const fromState = String(
    locationState?.submittedArtUrl || locationState?.artUrl || ""
  ).trim();
  return (
    fromState ||
    // Flower Garden sells the whole grown garden from the wall, not the one
    // canvas the last visitor happened to paint.
    String(stored.gardenSnapshotUrl || "").trim() ||
    String(stored.submittedArtUrl || "").trim() ||
    readShopArtUrl() ||
    String(stored.favouriteImageUrl || "").trim() ||
    String(stored.wordArtHeartChosenUrl || "").trim() ||
    String(stored.selfieArtImageUrl || "").trim() ||
    String(stored.voiceArtImageUrl || "").trim() ||
    ""
  );
}

export function saveShopArtUrl(url) {
  const next = String(url || "").trim();
  try {
    if (next) sessionStorage.setItem(ART_URL_KEY, next);
    else sessionStorage.removeItem(ART_URL_KEY);
  } catch {
    /* ignore quota — callers also pass the URL through route state */
  }
  return next;
}

export function clearShopCheckout() {
  saveShopCart([]);
  saveShopPayment({});
  saveShopArtUrl("");
}
